__turbopack_context__.v({
  "component": "BannerCTA-module__BP3R8q__component",
  "component__body": "BannerCTA-module__BP3R8q__component__body",
  "component__btn": "BannerCTA-module__BP3R8q__component__btn",
  "component__copy": "BannerCTA-module__BP3R8q__component__copy",
  "component__phoneBtn": "BannerCTA-module__BP3R8q__component__phoneBtn",
  "hide-for-large": "BannerCTA-module__BP3R8q__hide-for-large",
  "hide-for-large-only": "BannerCTA-module__BP3R8q__hide-for-large-only",
  "hide-for-medium": "BannerCTA-module__BP3R8q__hide-for-medium",
  "hide-for-medium-only": "BannerCTA-module__BP3R8q__hide-for-medium-only",
  "hide-for-small-only": "BannerCTA-module__BP3R8q__hide-for-small-only",
  "show-for-large": "BannerCTA-module__BP3R8q__show-for-large",
  "show-for-large-only": "BannerCTA-module__BP3R8q__show-for-large-only",
  "show-for-medium": "BannerCTA-module__BP3R8q__show-for-medium",
  "show-for-medium-only": "BannerCTA-module__BP3R8q__show-for-medium-only",
  "show-for-small-only": "BannerCTA-module__BP3R8q__show-for-small-only",
  "u-color-black": "BannerCTA-module__BP3R8q__u-color-black",
  "u-color-blue": "BannerCTA-module__BP3R8q__u-color-blue",
  "u-color-midnight": "BannerCTA-module__BP3R8q__u-color-midnight",
  "u-color-primary-dark": "BannerCTA-module__BP3R8q__u-color-primary-dark",
  "u-color-red": "BannerCTA-module__BP3R8q__u-color-red",
  "u-color-white": "BannerCTA-module__BP3R8q__u-color-white",
  "u-theme-black": "BannerCTA-module__BP3R8q__u-theme-black",
  "u-theme-blue": "BannerCTA-module__BP3R8q__u-theme-blue",
  "u-theme-dark": "BannerCTA-module__BP3R8q__u-theme-dark",
  "u-theme-light": "BannerCTA-module__BP3R8q__u-theme-light",
  "u-theme-red": "BannerCTA-module__BP3R8q__u-theme-red",
  "u-theme-white": "BannerCTA-module__BP3R8q__u-theme-white",
});
